<button type="button" (click)="onUpdateQr($event)">
  <sd-icon [type]="iconTypes.UPDATE_RESTORE"></sd-icon>
  <span class="text-b4-s-500">обновить код</span>
</button>
